<template>
<div :class="chave > actual && !isenabled ? 'text--disabled' : '' ">
  <h1 class="mb-3">
    {{ title }}
    <v-icon color="primary" v-if="isSelected" small>mdi-check</v-icon>
    <!-- <v-icon v-if="!emoji" small>mdi-check</v-icon> -->
  </h1>
</div>
</template>

<script>
export default {
  props: {
    title: String,
    emoji: Object,
    actual: Number,
    chave: Number,
    isenabled: Boolean,
    isSelected: Object
  },
}
</script>

<style>
.transluscid{
  opacity: 40%
}

</style>
